export default __webpack_public_path__ + "static/media/organic.db2e2cbd.png";